import { Paper, Stack, Typography } from "@mui/material";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";
import { distinctBy } from "@entrilia/shared/utilities/arrayHelper";
import type { ApprovalGroup, ApprovalStep } from "../../../../api/types/workflowTypes";
import UsersAvatarGroup from "../../../common/UsersAvatarGroup";
import NumberAvatar from "../../../common/NumberAvatar";

const getAllUsersForApprovalStep = (approvalStep: ApprovalStep, userGroups: ApprovalGroup[]) => {
  const allUsers = approvalStep.rules
    .flatMap((rule) => rule.groupIds)
    .map((groupId) => userGroups.find((group) => group.id === groupId)?.users)
    .filter((users) => users !== undefined)
    .flat();

  return distinctBy(allUsers, (user) => user.userId);
};

interface Props {
  approvalSteps: ApprovalStep[];
  userGroups: ApprovalGroup[];
}

const WorkflowApprovalSteps = ({ approvalSteps, userGroups }: Props) => {
  if (approvalSteps.length === 0) {
    return <Typography color="textSecondary">No approval steps configured yet.</Typography>;
  }

  return (
    <Stack spacing={0.5}>
      {approvalSteps.map((step, index) => {
        const users = getAllUsersForApprovalStep(step, userGroups);

        return (
          <Paper key={step.name} variant="outlined">
            <Stack direction="row" spacing={1} sx={{ alignItems: "center", p: 1 }}>
              <NumberAvatar number={index + 1} size={24} />
              <Typography variant="subtitle2" noWrap>
                {step.name}
              </Typography>
              <HorizontalFill />
              <UsersAvatarGroup users={users} />
            </Stack>
          </Paper>
        );
      })}
    </Stack>
  );
};

export default WorkflowApprovalSteps;
